import type { CiaDependencies } from '~/composables/useCia/types';
import { VERIFY_EMAIL } from '~~/constants/cia';

export interface VerifyEmailSuccessResponse {
  success: true;
}

export interface VerifyEmailErrorResponse {
  message: string;
  errors?: Record<string, string[]>;
}

export type VerifyEmailResponse = VerifyEmailSuccessResponse | VerifyEmailErrorResponse;

type VerifyEmailRequest = {
  user_id: string;
  locale: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, languageAndCountry } = dependencies;

  return async (userId: string): Promise<unknown> => {

    if (!userId) {

      return Promise.reject(new Error('User ID is required'));
    
    }

    const payload: VerifyEmailRequest = {
      user_id: userId,
      locale: languageAndCountry,
    };

    return fetch(`/cia/${VERIFY_EMAIL}`, {
      method: 'POST',
      body: payload,
    });
  
  };

};
